// Tabler outline v3.19.0 (MIT): sidebar collapse/expand + check/plus. Paths copied verbatim. Do not redraw.
import React from "react";

const base = (size, stroke) => ({
  width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor",
  strokeWidth: stroke, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true,
  style: { display: "block", flex: "none" },
});

export const IconSidebarCollapse = ({ size = 18, stroke = 1.75 }) => (
  <svg {...base(size, stroke)}><path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" /><path d="M9 4v16" /><path d="M15 10l-2 2l2 2" /></svg>
);
export const IconSidebarExpand = ({ size = 18, stroke = 1.75 }) => (
  <svg {...base(size, stroke)}><path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" /><path d="M9 4v16" /><path d="M14 10l2 2l-2 2" /></svg>
);
export const IconCheck = ({ size = 16, stroke = 1.75 }) => (
  <svg {...base(size, stroke)}><path d="M5 12l5 5l10 -10" /></svg>
);
export const IconPlus = ({ size = 16, stroke = 1.75 }) => (
  <svg {...base(size, stroke)}><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
);
